import {
  PAY_ON_ARRIVAL,
  PAY_PAL_SYSTEM,
  STRIPE_SYSTEM
} from 'constants/userSettings';

const getPayPalSettings = (isUpdate, paymentsForm) => {
  const payPalSettings = [];

  paymentsForm.payments.forEach(item => {
    if (item.paymentSystem === PAY_PAL_SYSTEM) {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};
      payPalSettings.push({
        ...idObj,
        clientId: item.clientId,
        clientSecret: item.clientSecret
      });
    }
  });
  return payPalSettings;
};

const getPayOnArrivalSettings = paymentsForm => {
  let payOnArrival = null;

  paymentsForm.payments.forEach(item => {
    if (item.paymentSystem === PAY_ON_ARRIVAL) {
      payOnArrival = true;
    }
  });
  return payOnArrival;
};

const getStripeSettings = (isUpdate, paymentsForm) => {
  const stripeSettings = [];

  paymentsForm.payments.forEach(item => {
    if (item.paymentSystem === STRIPE_SYSTEM) {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};
      stripeSettings.push({
        ...idObj,
        publishableKey: item.publishableKey,
        secretKey: item.secretKey
      });
    }
  });
  return stripeSettings;
};
export const prepareAllPaymentsSettingsData = (isUpdate, data) => {
  return {
    payPalSettings: getPayPalSettings(isUpdate, data),
    stripeSettings: getStripeSettings(isUpdate, data),
    payOnArrival: getPayOnArrivalSettings(data)
  };
};

export const getDeletedPaymentsSettings = data => {
  const deletedPayments = {
    PayPal: [],
    Stripe: [],
    'Pay on arrival': []
  };

  data.forEach(item => {
    deletedPayments[item.paymentSystem].push(item.id);
  });

  return deletedPayments;
};

export const getReceivedPaymentsData = data => {
  const payments = [];

  if (data.payPalSettings) {
    payments.push({
      id: data.payPalSettings.id ? parseInt(data.payPalSettings.id) : 0,
      clientId: data.payPalSettings.clientId,
      paymentSystem: 'PayPal',
      clientSecret: data.payPalSettings.clientSecret,
      isCreated: true
    });
  }

  if (data.stripeSettings) {
    payments.push({
      id: data.stripeSettings.id ? parseInt(data.stripeSettings.id) : 0,
      paymentSystem: 'Stripe',
      publishableKey: data.stripeSettings.publishableKey,
      secretKey: data.stripeSettings.secretKey,
      isCreated: true
    });
  }

  if (data.payOnArrivalPossibility) {
    payments.push({
      id: data.payOnArrivalPossibility.id
        ? parseInt(data.payOnArrivalPossibility.id)
        : 0,
      paymentSystem: 'Pay on arrival',
      isCreated: true,
      payOnArrivalPossibility: data.payOnArrivalPossibility.payOnArrival
        ? 'Yes'
        : 'No'
    });
  }
  return payments;
};

export const getReceivedIntegrationsData = data => {
  const integrations = [];
  if (data.trekksoftSettings) {
    integrations.push({
      id: data.trekksoftSettings.id ? parseInt(data.trekksoftSettings.id) : 0,
      apiClientId: data.trekksoftSettings.apiClientId,
      integrationPlatform: 'Trekksoft',
      apiClientSecret: data.trekksoftSettings.apiClientSecret,
      merchantName: data.trekksoftSettings.merchantName,
      isCreated: true
    });
  }

  if (data.expediaSettings) {
    integrations.push({
      id: data.expediaSettings.id ? parseInt(data.expediaSettings.id) : 0,
      username: data.expediaSettings.username,
      password: data.expediaSettings.password,
      integrationPlatform: 'Expedia',
      isCreated: true
    });
  }

  if (data.bookingSettings) {
    integrations.push({
      id: data.bookingSettings.id ? parseInt(data.bookingSettings.id) : 0,
      username: data.bookingSettings.username,
      password: data.bookingSettings.password,
      integrationPlatform: 'BOOKING',
      isCreated: true
    });
  }

  return integrations;
};

export const getTrekkSoftSettings = (isUpdate, integrationsForm) => {
  let trekkSoftSettings = {};
  integrationsForm.integrations.forEach(item => {
    if (item.integrationPlatform === 'Trekksoft') {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

      trekkSoftSettings = {
        ...idObj,
        apiClientId: item.apiClientId,
        apiClientSecret: item.apiClientSecret,
        merchantName: item.merchantName
      };
    }
  });
  return trekkSoftSettings;
};

export const getExpediaSettings = (isUpdate, integrationsForm) => {
  let expediaSettings = {};
  integrationsForm.integrations.forEach(item => {
    if (item.integrationPlatform === 'Expedia') {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};
      expediaSettings = {
        ...idObj,
        username: item.username,
        password: item.password
      };
    }
  });
  return expediaSettings;
};

export const getBookingSettings = (isUpdate, integrationsForm) => {
  let expediaSettings = {};
  integrationsForm.integrations.forEach(item => {
    if (item.integrationPlatform === 'BOOKING') {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};
      expediaSettings = {
        ...idObj,
        username: item.username,
        password: item.password
      };
    }
  });
  return expediaSettings;
};

export const getTrekkSoftCategoriesMapping = data => {
  const trekkSoftCategoriesMapping = [];
  if (data.trekksoftCategoriesMapping) {
    data.trekksoftCategoriesMapping.forEach(item => {
      trekkSoftCategoriesMapping.push({
        id: item.id ? parseInt(item.id) : 0,
        category: item.category,
        categoryOnTrekksoft: item.categoryOnTrekksoft,
        isCreated: true
      });
    });
  }
  return trekkSoftCategoriesMapping;
};

export const getDeletedIntegrationsSettings = data => {
  const deletedIntegrationsSettings = {
    Trekksoft: null,
    Expedia: null,
    BOOKING: null
  };

  data.forEach(item => {
    deletedIntegrationsSettings[item.integrationPlatform] = item.id;
  });

  return deletedIntegrationsSettings;
};

export const prepareCategoriesMappingData = (isUpdate, data) => {
  const preparedCategoriesMappingData = [];
  if (data.values.trekkSoftCategoriesMapping) {
    data.values.trekkSoftCategoriesMapping.forEach(item => {
      const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};
      preparedCategoriesMappingData.push({
        ...idObj,
        category: item.category,
        categoryOnTrekksoft: item.categoryOnTrekksoft
      });
    });
  }
  return preparedCategoriesMappingData;
};
